$(function() {
	$('#sectorSwitch').click(function() {
		// $('#sector1').velocity({
		// 	translateY: "-100%",
		// 	opacity: 0,
		// }, {duration: 400, display: "none"}, [0.42,0,0.086,0.8]);
		// $('#sector2')
		// .velocity({
		// 	translateY: "100%",
		// }, 0)
		// .velocity({
		// 	translateY: "0",
		// 	opacity: "1",
		// }, {duration: 400, delay: 410, display: "block"}, [0.42,0,0.086,0.8])


		TweenLite.to($('#sector1'), 0.5, { 
			y: "-100%",
			display: "none",
			ease:Power4.easeIn, 
		});
		TweenLite.to($('#sector2'), 0, { 
			y: "100%",
		});
		TweenLite.to($('#sector2'), 0.5, { 
			y: "0%",
			delay: 0.6,
			display: "block",
			ease:Power4.easeOut, 
		});		

		slideTop(400)
	});
	$('#sectorReturn').click(function() {
		TweenLite.to($('#sector2'), 0.5, { 
			y: "100%",
			display: "none",
			ease:Power4.easeIn, 
		});
		TweenLite.to($('#sector1'), 0.5, { 
			y: "0%",
			delay: 0.6,
			display: "block",
			ease:Power4.easeOut, 
		});

		slideTop(400)

		// $('#sector2').velocity({
		// 	translateY: "100%",
		// 	opacity: 0,
		// }, {duration: 400, display: "none"}, [0.42,0,0.086,0.8]);
		// $('#sector1')
		// .velocity({
		// 	translateY: "0",
		// 	opacity: "1",
		// }, {duration: 400, delay: 410, display: "block"}, [0.42,0,0.086,0.8])

		// $('#sector2').velocity({
		// 	translateY: "100%",
		// 	opacity: 0,
		// }, {display: "none"});
		// $('#sector1').velocity({
		// 	translateY: "0",
		// 	opacity: 1,
		// }, {display: "block"});
	});
});